// 👥 Employés E4b — onglets de la fiche : le changement d'onglet passe par la garde « modifications non enregistrées ».
import { Tabs } from '@/components/ui/tabs';
import { useEditionFiche } from '@/hooks/useEditionSection';

export function TabsFicheGardes({ value, onValueChange, children, ...props }) {
  const { demanderNavigation } = useEditionFiche();
  return <Tabs value={value} onValueChange={(v) => { if (v !== value) demanderNavigation(() => onValueChange(v)); }} {...props}>{children}</Tabs>;
}
